import React from "react";

import "./App.css";
import "./styles";
import "./menu.css";
import "yet-another-react-lightbox/styles.css";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import { InPersonSession } from "./pages/InPersonSession";
import { Navbar } from "./components/Navbar";
import { MentoringPage } from "./pages/Mentoring";
import { Footer } from "./components/Footer";

import { FormPage } from "./pages/Form";
import { LondonPage } from "./pages/London";
import ListOfPractices from "./pages/ListOfPractices";
import Gallery from "./pages/Gallery";
import { TheDescentPage } from "./pages/TheDescent";
import { TheDescentFaqPage } from "./pages/TheDescentFaq";

export default function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Switch>
          <Route path="/sessions" exact>
            <InPersonSession />
          </Route>

          <Route path="/sessions/list-of-practices" exact>
            <ListOfPractices />
          </Route>
          <Route path="/gallery" exact>
            <Gallery />
          </Route>

          <Route path="/mentoring">
            <MentoringPage />
          </Route>

          <Route path="/form">
            <FormPage />
          </Route>

          <Route path="/london">
            <LondonPage />
          </Route>

          <Route path="/the-descent/qa" exact>
            <TheDescentFaqPage />
          </Route>

          <Route path="/the-descent">
            <TheDescentPage />
          </Route>

          <Route path="/">
            <Home />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </>
  );
}
